<template>
  <right-structure :Pdatas='infoData'>
  </right-structure>
</template>

<script>
  import structure from "@/components/flowStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: null,
        responseCode: null,
        infoData: {
          flow: [
            {
              name: '扫码机绑定通道', 
              desc: [
                '1、设备绑定通道（两种方式）',
                {
                  preData: "A）：线下（设备）绑定通道，绑定后，停车场系统会将绑定信息主动推送给第三方，此时第三方系统需接入",
                  link:  "扫码机上报通道绑定关系",
                  url: "reportChannelBindForScan",
                  endData: " 接收通道-设备绑定信息，并保存; "
                },
                {
                  preData: "B）：第三方系统绑定，第三方系统通过接入",
                  link:  "向扫码机下发更新配置",
                  url: "cloudScanUpdateConfig",
                  endData: "主动绑定扫码机与通道的信息"
                },
                '2、扫码支付：',
                [
                  {
                    preData: "离场：车辆离场时，停车场系统会上报离场抓拍信息到第三方系统，此时第三方系统需接入",
                    link:  "预离场上报",
                    url: "reportPreCarOut",
                    endData: " 接收车辆抓拍信息"
                  },
                  {
                    preData: "第三方系统通过接口 ",
                    link:  "查费",
                    url: "getParkFee",
                    endData: " 对该车辆进行查费，若费用大于0，"
                  },
                  {
                    preData: "则通过接口 ",
                    link:  "向扫码机下发扫码请求",
                    url: "cloudScanQrCode",
                    endData: " 开启扫码机提示车主扫码，"
                  },
                  {
                    preData: "然后，通过接入接口 ",
                    link:  "扫码机上报扫码信息",
                    url: "reportQrCode",
                    endData: " 接收用户支付码信息进行扣费，"
                  },
                  {
                    preData: "在扣费成功后，调起我方接口 ",
                    link:  "缴费",
                    url: "payParkFee",
                    endData: " 同步账单到停车场，车场开闸车主离场，"
                  },
                  {
                    preData: "当接收到 ",
                    link:  "离场上报",
                    url: "reportCarOut",
                    endData: " 时，"
                  },
                  {
                    preData: "通过接口 ",
                    link:  "向扫码机下发停止扫码",
                    url: "cloudStopScanCode",
                    endData: " 指令关闭扫码机扫码动作"
                  },
                ]
                
              ], 
              url: '/static/img/扫码机对接流程.svg'
            },
          ],
        }
      }
    },
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/device/scan/scanMachineFlow.vue